/** A local navigation intent for the chat Help sheet, never a browser redirect. */
export function helpArticleSlug(path: string): string | null {
  return /^\/help\?article=([a-z0-9]+(?:-[a-z0-9]+)*)$/.exec(path)?.[1] ?? null;
}

export function helpDestination(slug: string): string { return `/help?article=${slug}`; }

export const OPEN_HELP_ARTICLE = 'mucka-open-help-article';
export type OpenHelpDetail = { slug: string; accepted?: boolean };
